export default __webpack_public_path__ + "static/media/forca.79dfc614.jpeg";